import poolHouseImg from '../../assets/pool-house.png'
import { Container, ColumnImage } from './styles'

export function SectionPiscina() {
  return (
    <>
      <Container>{/* <img src={poolHouseImg} alt="Pool House" /> */}</Container>
      <ColumnImage>
        <div style={{ backgroundImage: 'url(/tmp/pub.webp' }}>
          <h3>PUB</h3>
        </div>
        <div style={{ backgroundImage: 'url(/tmp/espacofit.webp' }}>
          <h3> ESPAÇO FIT</h3>
        </div>
        <div style={{ backgroundImage: 'url(/tmp/academia.webp' }}>
          {' '}
          <h3>ACADEMIA</h3>
        </div>
        <div style={{ backgroundImage: 'url(/tmp/spa.webp' }}>
          <h3>SPA</h3>
        </div>
      </ColumnImage>
    </>
  )
}

